// extracted by mini-css-extract-plugin
module.exports = {"title":"index_title_JCROv","btn":"index_btn_1ce50"};